export default {
	domain: {
		zonenscherm: 'zonenschermwebshop.nl',
		schipper: 'schipperwebshop.nl'
	},
	api: {
		development: 'zonenscherm-admin-master.test.flaire.nl',
		subdomain: 'admin',
		endpoint: 'api/configurator'
	},
	shop: {
		development: 'e2-zonscherm-master.test.flaire.nl',
		basket: 'purchase/basket',
		resource: 'e2/zonscherm/site/custom'
	}
};